<div class="bg-change-password bg-cover min-h-screen px-6">
  <div class="max-w-[1200px] mx-auto">
    <div
      class="w-[728px] mx-auto flex items-center justify-center min-h-[645px] max-lg:mb-[216px] max-sm:w-full"
    >
      <div class="w-full">
        <div class="flex items-center justify-center">
          <img src="../../../../assets/svg/recovery-pass.svg" />
        </div>
        <div *ngIf="isValid === undefined">
          <h3 class="text-2xl font-semibold text-light-blue text-center">
            Restablecer contraseña
          </h3>
          <p class="mt-2 font-light text-dark-gray text-center">
            Te recomendamos generar una contraseña fuerte
          </p>
        </div>
        <app-change-password
          [token]="token"
          *ngIf="isValid === undefined"
          (isValid)="isValid = $event"
        ></app-change-password>
        <div *ngIf="isValid" class="flex flex-col items-center gap-11 mx-auto">
          <span
            class="material-symbols-rounded text-6xl text-gray-2 font-semibold"
          >
            task_alt
          </span>
          <div class="flex flex-col gap-2 items-center">
            <p class="text-2xl font-semibold text-light-blue">
              ¡Contraseña restablecida!
            </p>
            <p class="text-m font-light text-dark-gray text-center">
              La contraseña fue restablecida con éxito, <br />
              ya puedes ingresar con la nueva información.
            </p>
          </div>
          <div class="w-[230px]">
            <avla-button
              class="avla-btn-init"
              theme="primary"
              label="Iniciar"
              (click)="next()"
              [isFluid]="true"
              [icon]="{
                type: 'class',
                icon: 'arrow_forward',
                class: 'material-symbols-rounded text-[20px]',
                position: 'right'
              }"
            ></avla-button>
          </div>
        </div>
        <div
          *ngIf="isValid === false"
          class="flex flex-col items-center gap-11 mx-auto"
        >
          <span
            class="material-symbols-rounded text-6xl text-fail font-semibold"
          >
            cancel
          </span>
          <div class="flex flex-col gap-2 items-center">
            <p class="text-2xl font-semibold text-fail">¡Lo sentimos!</p>
            <p class="text-m font-medium text-dark-gray text-center">
              El restablecimiento de contraseña no fue exitoso. <br />
              Por favor, inténtalo de nuevo.
            </p>
          </div>
          <div class="flex gap-11">
            <div class="w-[120px]">
              <avla-button
                class="avla-btn-purp avla-btn-flat-label-md"
                theme="primary"
                (click)="retrying()"
                label="Reintentar"
                [isFluid]="true"
              >
              </avla-button>
            </div>
            <div class="w-[120px]">
              <avla-button
                class="avla-btn-flat-label-md"
                theme="secondary"
                (click)="next()"
                label="Salir"
                [isFluid]="true"
              >
              </avla-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<img
  class="absolute left-0 top-[139px]"
  src="assets/svg/gradient-circle-left.svg"
  alt="Esfera gradiente izquierda"
/>
<img
  class="absolute right-0 bottom-0"
  src="assets/svg/gradient-circle-right.svg"
  alt="Esfera gradiente derecha"
/>
